import React, { FC } from 'react';

import { FlexItemProps } from './Flex.types';
import { getClassNames } from './FlexItem.styles';

const FlexItem: FC<FlexItemProps> = ({ children, ariaHidden, role, ...styleProps }) => {
  const classNames = getClassNames(styleProps);

  /**
   * This inline style is necessary to allow the minWidth prop to
   * override the higher-specificity style set by the <Flex> parent.
   */
  const style = styleProps.minWidth ? { minWidth: styleProps.minWidth } : undefined;

  return (
    <div className={classNames.flexItem} role={role} aria-hidden={ariaHidden} style={style}>
      {children}
    </div>
  );
};

/**
 * A `FlexItem` component renders a div with flex-item styles.
 */
export default FlexItem;
